import { Injectable } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { filter, tap } from 'rxjs/operators';
import { WebSocketService } from 'src/app/api/web-socket.service';
import { CandleSticks } from 'src/app/models/candle-stick';
import { WebSocketStatus } from 'src/app/models/wss';

@Injectable({
  providedIn: 'root'
})
export class WebsocketCandleStickService {
  private pair: string;
  private interval: number;
  private subscription: Subscription;
  private websocketStatusSubscription: Subscription;
  private subject = new Subject<CandleSticks>();
  private connected = false;

  constructor(private wss: WebSocketService) {
  }

  init() {
    this.websocketStatusSubscription = this.wss.statusCahnges.subscribe(status => {

      if(status === WebSocketStatus.Connected && !this.connected) {
        this.connected = true;
        this.connect();
        return;
      }

      if(status === WebSocketStatus.Closed) {
        this.connected = false;
      }

    });
  }

  get(pair: string, interval: number) {
    if(this.pair === pair && this.interval === interval) {
      return this.subject;
    }

    this.pair = pair;
    this.interval = interval;

    if (!this.connected) {
      this.connected = true;
      this.init();
    }

    this.connect();

    return this.subject;
  }

  disconnect() {
    this.pair = null;
    this.interval = null;
    this.connected = false;
    this?.subscription?.unsubscribe();
    this?.websocketStatusSubscription?.unsubscribe();
  }

  private connect() {
    if (!this.pair || !this.interval) {
      return;
    }

    this.subscription?.unsubscribe();

    this.subscription = this.wss.realTimeCandles(this.pair,this.interval).pipe(
      filter(response => {
        if (!response?.data) {
          return false;
        }

        return true;
      }),
      tap(candlesResponse => {
        this.subject.next(candlesResponse);
      })
    ).subscribe();
  }
}
